export default __webpack_public_path__ + "static/media/logout.c961aaa9.svg";